import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556f2398"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-box" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "leftBox" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "appName" }
const _hoisted_6 = { class: "rightBox" }
const _hoisted_7 = { class: "content" }

import { computed, ref } from "vue";
import leftTabs from "@/components/chat/leftTabs.vue";
import rightContent from "@/components/chat/rightContent.vue";
import datePicker from "@/components/chat/datePicker.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { event } from "vue-gtag";
import { gaEvent } from "@/utils/format";


export default /*#__PURE__*/_defineComponent({
  __name: 'chat',
  props: {
  // 需要展示的tab项（会话、联系人、通话）
  tabs: {
    type: Array,
    default: ["Contact", "Mail", "Phone"],
  },
  appInfo: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props

const store = useStore();

const route = useRoute();


// console.log(props.tabs, "props.tabs");

const tabs = [
  {
    name: "first",
    label: "Contact",
    icon: require("@/assets/chat/comment_default.svg"),
    iconActive: require("@/assets/chat/comment_active.svg"),
  },
  {
    name: "second",
    label: "Mail",
    icon: require("@/assets/chat/avatar_active.svg"),
    iconActive: require("@/assets/chat/avatar_default.svg"),
  },
];

const currentMonitorApp = computed(() => store.state.currentMonitorApp);

// console.log(currentMonitorApp.value, 'currentMonitorApp chat.vue');

const appFrom = computed(() => store.state.appFrom);

if (appFrom.value) {
  gaEvent(`${currentMonitorApp.value.eventNamePre}_PV`, {
    event_category: currentMonitorApp.value.category,
    event_label: appFrom.value,
  });
}

const handleDateChange = (value: any) => {
  store.commit("setDatePickerValue", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: __props.appInfo.icon,
          alt: "",
          class: "iconImg"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.appInfo.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(datePicker, { onChange: handleDateChange })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(leftTabs, {
        tabs: props.tabs,
        appName: __props.appInfo.name.toLowerCase()
      }, {
        phoneItem: _withCtx(({ item }) => [
          _renderSlot(_ctx.$slots, "phoneItem", {
            item: item.item
          })
        ]),
        _: 3
      }, 8, ["tabs", "appName"]),
      _createVNode(rightContent, {
        appName: __props.appInfo.name.toLowerCase()
      }, {
        phoneContentItem: _withCtx(({ phoneItemDetail }) => [
          _renderSlot(_ctx.$slots, "phoneContentItem", { phoneItemDetail: phoneItemDetail })
        ]),
        chatContentItem: _withCtx(({ msgObj }) => [
          _renderSlot(_ctx.$slots, "chatContentItem", { msgObj: msgObj })
        ]),
        _: 3
      }, 8, ["appName"])
    ])
  ]))
}
}

})